// import "../../StudentManagement.scss";
import { CustomButton, SearchBar, SwitchButton } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal } from "components/modals/ModalBox";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { userPlaceholder } from "assets/icons";
import findSerialNumber from "utils/findSerialNumber";
import { limitOption, userRoleOptions } from "constants/staticData";
import {
  capitalizeAndJoin,
  firstWordCapital,
  getValueOrFallback,
} from "utils/common";
// import DeleteSelectedUser from "./DeleteSelectedUser";
import { categoryListApi, updateCategoryApi } from "services/category";
import { formatToDDMMYYYY } from "utils/dateFormat";
import DeleteSurveyCategory from "./DeleteSurveyCategory";
import AddSurveyCategory from "./AddSurveyCategory";
import { IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';

const UserManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [addCategoryModel, setAddCategoryModel] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [search, setSearch] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();
  const activePage = +searchParams.get("page") || 1;
  const limits = +searchParams.get("limit") || 10;
  const [total, setTotal] = useState(null);
  const [deleteModel, setDeleteModel] = useState(false);
  const [selectedCategoryDetail, setSelectedCategoryDetail] = useState({});
  const searchDebounce = useDebounce(search, 300);
  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");


  // delete handler function
  const userDeleteHandler = (userData) => {
    setDeleteModel(true);
    setSelectedCategoryDetail(userData);
  };

  //Reset all value
  const resetFilterHandler = () => {
    setSearch("");
    searchParams.delete("page");
    searchParams.delete("limit");
    setSearchParams(searchParams);
  };

  // Handle pagination
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  // handle limit of page
  const handleLimit = (event) => {
    searchParams.set("limit", event.target.value);
    searchParams.delete("page")
    setSearchParams(searchParams);
  };

  // user list handler
  const surveyCategoryListHandler = async () => {
    try {
      onShow();
      const reqData = {
        pagination: "true",
        page: activePage,
        limit: limits,
        ...(search && searchDebounce && { search: searchDebounce }),
      };
      const { data, status } = await categoryListApi(reqData);

      if (status === 200) {
        setTotal(data?.meta?.totalRecords);
        setCategoryList(data?.data);
      }
    } catch (e) {
      console.log(e);

      // toast.error(e.message);
    } finally {
      onHide();
    }
  };

  // update category Status
  const updateStatus = async (_id, status) => {
    try {
      onShow();
      const reqData = {
        _id,
        status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const { data } = await updateCategoryApi(reqData);
      surveyCategoryListHandler();
    } catch (e) {
      console.log(e);
      // toast.error(e.message);
    } finally {
      onHide();
    }
  };

  const showImagePreviewHandler = (profile) => {
    setShowImagePreviewModel(true);
    setImagePreview(profile);
  };



  // on close
  const onClose = () => {
    setSelectedCategoryDetail({});
    setDeleteModel(false);
    setAddCategoryModel(false);
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    surveyCategoryListHandler();
  }, [searchParams, activePage, limits, searchDebounce]);

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>Category Management</h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search"}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <CustomButton
              type="button"
              className="button"
              onClick={() => setAddCategoryModel(true)}
            >
              Add
            </CustomButton>
            <CustomButton onClick={resetFilterHandler}>
              <SlRefresh />
            </CustomButton>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">S.No</th>
                    <th className="nowrap text-center">Image</th>
                    <th className="nowrap text-center">Category</th>
                    <th className="nowrap text-center">No. of L1 Groups</th>
                    <th className="nowrap text-center">No. of L2 Groups</th>
                    <th className="nowrap text-center">No. of L3 Groups</th>
                    <th className="nowrap text-center">No. of L4 Groups</th>
                    <th className="nowrap text-center">Added On</th>
                    <th className="nowrap text-center">Status</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {categoryList && categoryList.length ? (
                    categoryList?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="nowrap text-center">
                            {findSerialNumber(index, activePage, limits)}
                          </td>

                          <td className="nowrap text-center text-capitalize">
                            <img
                              src={data.image}
                              width={50}
                              height={50}
                              style={{ borderRadius: "50%" }}
                              className="avatar"
                              onClick={() =>
                                showImagePreviewHandler(data?.image)
                              }
                            />
                          </td>
                          <td className="nowrap text-center text-capitalize">
                            {firstWordCapital(data?.name || "---")}
                          </td>
                          <td className="nowrap text-center">
                            0
                          </td>
                          <td className="nowrap text-center">
                            0
                          </td>
                          <td className="nowrap text-center">
                            0
                          </td>
                          <td className="nowrap text-center">
                            0
                          </td>
                          <td className="nowrap text-center">
                            {formatToDDMMYYYY(data?.createdAt)}
                          </td>
                          <td className="nowrap text-center">
                            <SwitchButton readOnly={false} status={data?.status === "ACTIVE" ? true : false} onClick={e => updateStatus(data?._id, data?.status)} />
                          </td>
                          <td>
                            <div className="icon_wrap">
                              <IconButton
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedCategoryDetail(data);
                                  setAddCategoryModel(true);
                                }}
                              >
                                <EditIcon className="icon_button" />
                              </IconButton>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  userDeleteHandler(data);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={10}
                      msg={"User Data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>

            <div className="pagination-wrapper">
              <div className="Pagination">
                <select
                  className="input form-control"
                  value={limits}
                  onChange={handleLimit}
                >
                  {limitOption &&
                    limitOption.length > 0 &&
                    limitOption.map((limitValue) => (
                      <option key={limitValue.value} value={limitValue.value}>
                        {limitValue.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Survey Category */}
      {deleteModel && (
        <DeleteSurveyCategory
          selectedCategoryDetail={selectedCategoryDetail}
          onClose={() => onClose()}
          setCategoryList={setCategoryList}
          deleteModel={deleteModel}
          surveyCategoryListHandler={surveyCategoryListHandler}
        />
      )}

      {/* Delete Survey Category */}
      {addCategoryModel && (
        <AddSurveyCategory
          onClose={() => {
            onClose();
            setSelectedCategoryDetail(null);
          }}
          addCategoryModel={addCategoryModel}
          surveyCategoryListHandler={surveyCategoryListHandler}
          data={selectedCategoryDetail}
        />
      )}


      {/* Image Preview model */}
      <CustomModal
        className={"sm image_preview_modal"}
        show={showImagePreviewModel}
        handleClose={() => {
          setImagePreview("");
          setShowImagePreviewModel(false);
        }}
      >
        <div className="image_preview">
          <img
            src={imagePreview || userPlaceholder}
            alt="user-profile-preview"
          />
        </div>
      </CustomModal>
    </>
  );
};

export default UserManagement;
